import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environment/environment';

/** Authenticated peer-review entry — no Billing View/Manage requirement. */
export const invoicePeerReviewGuard: CanActivateFn = () => {
  if (environment.enableBillingModule !== true) {
    return inject(Router).createUrlTree(['/dashboard', 'home']);
  }
  return true;
};
